//setup window helpers
  window._s1 = window._s1 || {};

 window.setQuickBuyDrawerQuantity = (ele,qty) => {
    const newPriceStr = `${ele.dataset.price} ea.`;
    const openDrawer = [...$('.quick-buy-drawer')].filter(e => $(e).is(':visible'))[0];
    const $activeButton = $(openDrawer).find('.block-swatch');
    const $price = $(openDrawer).find('.drawer-price');
    const $newPrice = $(openDrawer).find('.new-price');
    
    $activeButton.css('border', '');
    $price.css('text-decoration', 'line-through').css('color', 'red');
    $newPrice.text(newPriceStr);
    
    ele.style.border='2px solid black';
    $(openDrawer)
      .find('.quantity-selector input')
      .val(qty)
      .trigger("input");
  }

  window.handleGift = async (key) => {
    const region = _s1.getS1Region();
    const gift_variant_map = {
      us: {
        "100": 42409048539286,
        "150": 42409048572054,
        "200": 42409048604822
      },
      uk: {
        "20": 34581861531785,
        "50": 34581861564553,
        "100": 34581861597321
      }, 
      au: {
        "100": 39738961952840,
        "150": 39738961985608,
        "200": 39738962018376
      }
    }
    const $button = $(`button#gift-${key}`);
    
    if($button.length > 0){
      $button.attr('aria-busy', true);
    }
    
    const variant_id = gift_variant_map[region][key];
    await _s1.addToCartAndRefreshCart([{
        id: variant_id,
        quantity: 1
      }])

    if($button.length > 0){
      $button.attr('aria-busy', false);
    }
    
  }

  _s1.addToCartAndRefreshCart = async (items) => {
      const response = await _s1.addToCart(items);
      return await _s1.refreshCart(response);
  }

  _s1.getSetABExperiment = (experiment_key) => {
    const exp = Cookies.get(experiment_key);
    if(exp) return exp;
    const randomNumber = Math.random();
    const new_exp = randomNumber < 0.5 ? "A" : "B";
    Cookies.set(experiment_key,new_exp);
    return new_exp;
  }

  _s1.addCartListener = (callback) => {
    (function(ns, fetch) {
      if (typeof fetch !== 'function') return;
    
      ns.fetch = function() {
          const response = fetch.apply(this, arguments);
    
          response.then(res => {
            const base_res_url = res.url.split('?')[0];
              if ([
                      `${window.location.origin}/cart/add.js`,
                      `${window.location.origin}/cart/update.js`,
                      `${window.location.origin}/cart/change.js`,
                      `${window.location.origin}/cart/clear.js`,
                  ].includes(base_res_url)) {
                  res.clone().json().then(data => callback(data));
              }
          });
    
          return response;
      }
    
    }(window, window.fetch))
  }

  _s1.getCurrentBaseURL = () => {
    const region = _s1.getS1Region();
    return _s1.getBaseURLFromRegion(region);
  }

  _s1.getBaseURLFromRegion = (region) => {
    if(region === 'uk') return 'https://europe-central2-stepone-backend-uk.cloudfunctions.net';
    if(region === 'us') return 'https://us-central1-stepone-backend-us.cloudfunctions.net';
    return 'https://australia-southeast1-stepone-backend.cloudfunctions.net'
  }

  _s1.getS1Region = () => {
    if(window.location.href.includes('uk.stepone')) return 'uk';
    if(window.location.href.includes('us.stepone')) return 'us';
    return 'au';
  }

  _s1.getCountryCode = async () => {
    const response = await fetch('/browsing_context_suggestions.json');
    const json = await response.json()
    return json.detected_values;
  }

  _s1.addToCart = async (items) => {

    const response = await fetch(`/cart/add.js?sections=${window.CartSectionID},variant-added`, {
        body: JSON.stringify({items}),
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json"
        }
      });
  
    return await response.json();
  
  }

_s1.artificalRemoveStock = () => {
    if(!window.location.href.includes('/products')) return;
    _s1.queue(function(){
        return jQuery && jQuery('label.block-swatch').length > 0 && jQuery('input.sr-only').length > 0
    }, function(){
        jQuery('label.block-swatch').addClass('is-disabled');
        jQuery('input.sr-only').click(function(e){
            e.preventDefault();
        })
    })
}

_s1.addDiscountToCart = async (discountCode, notify = false) => {
    await fetch(`/discount/${discountCode}`);
    if(notify){
      _s1.notify('Your Discount Has Been Applied');
    }
  }
  
  _s1.refreshCart = async (response) => {
  
  const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
  
  cartContent["sections"] = response.sections;
  
  document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
    bubbles: true,
    detail: {
      items: response.hasOwnProperty("items") ? response["items"] : [response],
      cart: cartContent
    }
  }));
  
  document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
    bubbles: true,
    detail: {
      baseEvent: "variant:add",
      cart: cartContent
    }
  }));
}

_s1.notify = (message, colour = '#28a745', delay = 2000) => {
  $('#notification-bar')
    .text(message)
    .css('background-color', colour)
    .slideDown(300)
    .delay(delay)
    .slideUp(300);
}

_s1.classOnMobile = (ele, className) => {
  // Create a media query list for screens with max-width 999px.
  const mediaQuery = window.matchMedia('(max-width: 999px)');

  // This function applies or removes the class based on the media query.
  const toggleClass = (e) => {
    if (e.matches) {
      // If mobile: add the class if it's not already there.
      ele.classList.add(className);
    } else {
      // Otherwise: remove the class.
      ele.classList.remove(className);
    }
  };

  // Run the function immediately to set the correct class on page load.
  toggleClass(mediaQuery);

  // Listen for changes in the media query.
  // Modern browsers support addEventListener; older ones might need addListener.
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', toggleClass);
  } else if (mediaQuery.addListener) {
    mediaQuery.addListener(toggleClass);
  }
}

_s1.getCart = async () => {
    const res = await fetch('/cart.js');
    return await res.json();
}

_s1.swapImageSrcset = (img, newSrc) => {

    if (!img || !newSrc) return;
    
    img.src = newSrc;
    img.srcset = newSrc;
}

_s1.addAttributeToOrder = (key,value) => {
  return fetch('/cart', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              attributes: {
                  [key]: value
              }
          })
      });
}

_s1.getQueryParam = (key) => {
   const current_url = new URL(window.location.href);
   const param = current_url.searchParams.get(key);
  return param;
}

_s1.queue = function(){
  if(arguments.length == 0)
      return;
  var i = 0,
      maxlimit = 1000,
      limit = maxlimit,
      args = arguments;
  var x = setInterval(function(){
      var r = false;
      try{
          r = args[i]();
      } catch(e) {
          clearInterval(x);
          return;
      }
      
      if(r)
      {
          limit = maxlimit;
          i++;
          if(i >= args.length)
              clearInterval(x);
      }
  
      if(limit < 0) clearInterval(x);
      limit--;
  }, 50);
};

// custom logic for PDP
(() => {

  // KLAVIYO BIRTHDAY CUSTOM LOGIC
  window.addEventListener("klaviyoForms", function(e) { 

     if(e.detail.type != 'submit') return;
     if(e.detail.metaData.$source !== 'Birthday Sign Up Page') return;
     
     const {
        date_of_birth,
        customer_sex,
        preferred_print_type,
        preferred_size
     } = e.detail.metaData;
  
     const date_parts = date_of_birth.split('/');
     const month_day = `${date_parts[0]}/${date_parts[1]}`;
     const year = date_parts[2]
  
    _learnq.push(['identify', {
        date_of_birth,
        Birthday: `${month_day}/${new Date().getFullYear()}`,
        birthday_year: Number(year),
        customer_sex,
        preferred_print_type,
        preferred_size,
    }]);
  
   });

  // DISCOUNT APPLICATION CODE
  const current_url = new URL(window.location.href);
  const discountParam = current_url.searchParams.get('discount');
  if(discountParam){
    _s1.addDiscountToCart(discountParam);
  }

  $(document).ready(function(){

    const showGenderProductTab = () => {

      const initV1TabChange = () => {
        const hasProductTabs = $('.product_tabs').length > 0;
        const isProductPage = window.location.href.includes('/products');
        if(isProductPage) return;
        if(!hasProductTabs) return;
        
        _s1.queue(function(){
          return $('.product_tabs a[data-tabnum="1"]')[0];
        }, function(){
          $('.product_tabs a[data-tabnum="1"]')[0].click();
          return true
        })
        
      }

      const initV2TabChange = () => {
        console.log('running');
        const $womensTab = $('.product_catalog_tabs.product_tabs a[data-gender="womens"]');
        if($womensTab.length === 0) return;
        $womensTab.click();
      }

      const campaignName = _s1.getQueryParam('utm_campaign');
      if(campaignName && campaignName.toLowerCase().includes('women')){
        initV1TabChange();
        initV2TabChange();
      }
    }

    const addAttributeForRefferingFriend = () => {
      const queryRef = _s1.getQueryParam('mys24_ref_sender');
      const cookieRef = Cookies.get('mys24_ref_sender');
      const hasRef = queryRef || cookieRef;
      if(!hasRef) return;
      Cookies.set('mys24_ref_sender', hasRef);
      _s1.addAttributeToOrder('mys24_ref_sender', hasRef);
    }

    const getButtonFromSelectedSize = (size) => {
      const btn = document.querySelector(`input.sr-only[value="${size}"]`);
      if(btn) return btn;

      const fallbackMap = {
        "S" : "Small",
        "Small": "S",
        "M": "Medium",
        "Medium": "M",
        "Large": "L",
        "L": "Large"
      }

      const fallbackValue = fallbackMap[size];
      const fallbackBtn = document.querySelector(`input.sr-only[value="${fallbackValue}"]`);

      if(fallbackBtn) return fallbackBtn;
      return false;
    }

    const initFatherAndSon = () => {
      
      	function addNavSize(size, pageLocation = '#', prepend = false){
    		const template = `
    			<a href="${pageLocation}">
    				<input class="sr-only" type="radio" name="option2" value="${size.toUpperCase()}">
    				<label class="block-swatch is-size-${size.toLowerCase()}">
    		          <span>${size.toUpperCase()}</span>
    		     	</label>
    	     	</a>
    		`
    		if(prepend){
    			$($('.variant-picker__option-values')[3]).prepend(template)
    		} else {
    			$($('.variant-picker__option-values')[3]).append(template);
    		}
    	}
    
    	const isTrunk = window.location.href.includes('junior-trunk');
    	const isBoxerBrief = window.location.href.includes('boxer-brief');
    	const isSon = window.location.href.includes('son');
    
    	if(isTrunk && isSon){
    		const boxer_sizes = ['S', 'M'];
    		for(const size of boxer_sizes){
    			addNavSize(size, `/products/boxer-brief-son?size=${size}#product-tab-originals`)
    		}
    	}
    
    	if(isBoxerBrief && isSon){
    		const trunk_sizes = ['4XS', '3XS', '2XS', 'XS'].reverse();
    		for(const size of trunk_sizes){
    			addNavSize(size, `/products/junior-trunk-son?size=${size}#product-tab-originals`, true)
    		}
    	}

        const prefilled_size = _s1.getQueryParam('size');
        if(!prefilled_size) return;
        const sizeBtn = getButtonFromSelectedSize(prefilled_size);
        let hasRun = false;
         document.addEventListener('disabled-variants-updated', function(){
           if(hasRun) return;
           sizeBtn.click();
           hasRun = true;
         })
    }


    const initScrollFromBanner = () => {
      const $banner = $('.content-over-media');
      const $tabs = $('.product_tabs');
      if($banner.length == 0 || $tabs.length == 0) return;
      $banner.click(function() {
          $('html, body').animate({
              scrollTop: $tabs.offset().top - 100
          }, 10);
      });
    }

    const initProductCardsSwatches = () => {
      const $swatches = $('.product-card-swatch .color-swatch');
      if($swatches.length === 0) return;
      $swatches.click(function(e){
        e.preventDefault();
        
        const $parent = $(e.currentTarget).parent();
        const newSrc = $parent.data('imgSrc');
        
        const quickBuyId = $parent.data('quickBuyId');
        const quickBuyDraw = $(`#${quickBuyId}`);
        const productHandle = quickBuyDraw.attr('handle');
        
        const $productCard = $(e.currentTarget).parents('.multi-column__item');
        
        const img = $productCard.find('img')[0];
        const a = $productCard.find('a')[0];
        const addBtn = $productCard.find('#bfcm-quick-btn')[0];
        const shopAllBtn = $productCard.find('.product-card-button:not(#bfcm-quick-btn)')[0];

        shopAllBtn.setAttribute('href', `/products/${productHandle}`);
        a.setAttribute('href', `/products/${productHandle}`);
        addBtn.setAttribute('aria-controls', quickBuyId);
        _s1.swapImageSrcset(img, newSrc);
      })
    }

    const initSurfPages = async () => {
      if(!window.location.href.includes('/pages/slsa-clubs')) return;
      const club_name = _s1.getQueryParam('club');
      if(!club_name) window.location.href = '/pages/slsa-pick-your-club';
      _s1.addAttributeToOrder('slsa-selected-club',club_name).then(res => res.json()).then(console.log);
      $('.club-name').text(club_name);
      console.log('done');
    }

    const initSurfDonationBanner = async () => {
      if(!window.location.href.includes('/products/') || ! (window.location.href.includes('slsa') || window.location.href.includes('nippers') ) ) return;
      const cart = await _s1.getCart();
      const club = cart.attributes['slsa-selected-club'];
      if(!club) return;
      $(`<div class="banner" style="
          background-color: #ffd10c;
          color: #e10011;
          border-radius: 20px;
          font-weight: bold;
          justify-content: center;">
          Upon purchase $5 will go to: ${club}
        </div>`).insertBefore('.buttonwrap')
    }

    const club_name = _s1.getQueryParam('club');
    if(club_name){
      _s1.addAttributeToOrder('slsa-selected-club',club_name);
    }

    const initDiscountBarV3 = () => {

      const discountTiers = _s1.getTieredPricing();
  
      function setTierTextColour(tier, progress){
        [...document.querySelectorAll(`.tier-text-${tier}`)]
          .forEach(tier => tier.style.color = progress >= 100 ? 'var(--yellow-color)' : 'white');
      }

      function setTierProgress(tier, progress){
        [...document.querySelectorAll(`#progress-fill-${tier}`)]
          .forEach(tier => tier.style.width = progress > 0 ? `${progress}%` : '0');
      }

      function updateTier(tier,progress){
        setTierProgress(tier,progress);
        setTierTextColour(tier,progress);
      }
  
      function updateDiscountBars(itemCount) {
  
        const tier1Progress = Math.min((itemCount / discountTiers.low_tier.threshold) * 100, 100);
        const tier2Progress = Math.min(( (itemCount - discountTiers.low_tier.threshold) / (discountTiers.mid_tier.threshold - discountTiers.low_tier.threshold)) * 100, 100);
        const tier3Progress = Math.min(( (itemCount - discountTiers.mid_tier.threshold) / (discountTiers.high_tier.threshold - discountTiers.mid_tier.threshold)) * 100, 100);

        updateTier('1', tier1Progress);
        updateTier('2', tier2Progress);
        updateTier('3', tier3Progress);
        
        // Update message
        let message = `Add ${discountTiers.low_tier.threshold - itemCount} items to save ${discountTiers.currency}${discountTiers.low_tier.discount_total} on your order!`;
        if (itemCount >= discountTiers.high_tier.threshold) {
          message = `You're saving <span class="stagared-chip yellow">${discountTiers.currency}${discountTiers.high_tier.discount_total}</span> on your order!`;
        } else if (itemCount >= discountTiers.mid_tier.threshold) {
          message = `Add <span class="stagared-chip">${discountTiers.high_tier.threshold - itemCount}</span> more to save <span class="stagared-chip yellow">${discountTiers.currency}${discountTiers.high_tier.discount_total}</span>`;
        } else if (itemCount >= discountTiers.low_tier.threshold) {
          message = `Add <span class="stagared-chip">${discountTiers.mid_tier.threshold - itemCount}</span> more to save <span class="stagared-chip yellow">${discountTiers.currency}${discountTiers.mid_tier.discount_total}</span>`;
        } else if (itemCount > 0) {
          message = `Add <span class="stagared-chip">${discountTiers.low_tier.threshold - itemCount}</span> more to save <span class="stagared-chip yellow">${discountTiers.currency}${discountTiers.low_tier.discount_total}</span>`;
        }

        if(document.getElementById('discount-text')){
          document.getElementById('discount-text').innerHTML = message;
        }
        
      }

      function setupLabels(){
        $('.tier-text-1.pack').text(`${discountTiers.low_tier.threshold} Pack`);
        $('.tier-text-2.pack').text(`${discountTiers.mid_tier.threshold} Pack`);
        $('.tier-text-3.pack').text(`${discountTiers.high_tier.threshold} Pack`);
      }
  
      async function getEligableCartItemCount(){
        const cart = await _s1.getCart();
        let count = 0;
        for(const item of cart.items){
          if(item.title.includes('Police')) continue;
          count += item.quantity
        }
        return count;
      }
  
      async function updateFromCart() {
          const cartItemCount = await getEligableCartItemCount();
          updateDiscountBars(cartItemCount);
        }
  
      _s1.addCartListener(updateFromCart);
      updateFromCart();
      setupLabels();
    }

    const initProductCardSwatchesV2 = () => {
      const $swatches = $('.product-card-swatch > .color-swatch');
      if($swatches.length === 0) return;
      $swatches.click(function(e){
        e.preventDefault();
        
        const $parent = $(e.currentTarget).closest('.product-card-swatch');
        const newSrc = $parent.data('imgSrc');
        
        const quickBuyId = $parent.data('quickBuyId');
        const price = $parent.data('price');
        const quickBuyDraw = $(`#${quickBuyId}`);
        const productHandle = quickBuyDraw.attr('handle');
        
        const $productCard = $(e.currentTarget).closest('.catalog_product');
        
        const img = $productCard.find('img')[0];
        _s1.swapImageSrcset(img, newSrc);
        
        const a = $productCard.find('a')[0];
        a.setAttribute('href', `/products/${productHandle}`);
        
        const addBtn = $productCard.find('#catalog_product_cta_atc')[0];
        addBtn.setAttribute('aria-controls', quickBuyId);
        
        const shopAllBtn = $productCard.find('.catalog_product_cta a')[0];
        shopAllBtn.setAttribute('href', `/products/${productHandle}`);

        const $price = $productCard.find('.catalog_product_price');
        $price.text(price);
        
      })
    }

    const initProductCardSwitcher = () => {
      const $tabs_container = $('.product_catalog_tabs');
      if($tabs_container.length === 0) return;

      const $sections = [...$('.catalog_product_container')].map(e => $(e));

      const $getVisibleTab = () => {
        return $($sections.filter(e => !e.is(':hidden'))[0][0]);
      }

      const resetScrollAndButtons = () => {
        $sections.forEach($section => {
          $section.scrollLeft(0);
          $('.scroll-left').addClass('disabled');
          $('.scroll-right').removeClass('disabled');
        })
      }

      const possibleTabs = ['mens', 'womens', 'kids', 'boys', 'girls']
      const $tabs = possibleTabs.map(tabName => $('.product_catalog_tabs').find(`a[data-gender="${tabName}"]`));
      
      for(const tabName of possibleTabs){
        const $tab = $('.product_catalog_tabs').find(`a[data-gender="${tabName}"]`);
        const $section = $(`.catalog_product_container.${tabName}`);

        $tab.click(function(){
          if($tab.hasClass('active'))return;
          $getVisibleTab().fadeOut(350, function(){
              $section.fadeIn();
              $tabs.forEach($tab => $($tab).removeClass('active'));
              $tab.addClass('active')
              resetScrollAndButtons();
          });
        })
      }
      
    }

    const initAmbassadorTracking = async () => {
      const code = _s1.getQueryParam('s1_amb');
      if(!code) return;
      _s1.addAttributeToOrder('s1_amb',code.toLowerCase()).then(res => res.json()).then(console.log);
      console.log('s1_amb:', code);
    }

    const initCloudMeshSignUp = () => {
      let formId = 'Vizb4j';
      if(window.location.href.includes('uk.stepone.life')){
       formId = 'Ty6HvP'
      }
      const isCloudMesh = window.location.href.toLowerCase().includes('cloud-mesh');
      if(isCloudMesh){
        setTimeout(function(){
           window._klOnsite.push(['openForm', formId]);
        }, 2000)
       
      }
    }

    // ******* Start New Pack Buttons

    window.openBundleBuilder = () => {
      const tiers = _s1.getTieredPricing();
      const $drawer = jQuery('x-drawer.bundle-builder-drawer');
      if(!!window.setPackQty) window.setPackQty(tiers.mid_tier.threshold);
      // $drawer.find('.depressed_btn[data-qty="7"]').click();
      if($drawer.length > 0) $drawer[0].show();
    }

    const setProductStrikePriceAndRing = (showNormal, price) => {
      const $price_section = $('.product-price');
      const $main_price = $price_section.find('.main-price');
      const $new_price = $price_section.find('.new-price');

      $(`.product_pack_button`).removeClass('active');
      const $active_btn = $(`.product_pack_button[data-price="${price}.00"]`);
      $active_btn.addClass('active');
      
      if(showNormal){
        $main_price.css('text-decoration', '');
        $new_price.hide();
      } else {
        $new_price.show();
        $main_price.css('text-decoration', 'line-through');
        $new_price.text(`£${price} ea`);
      }
    }

    const setPackButtonsQuantity = () => {

      console.log('running');
      
      if(!window.location.href.includes('/products/')) return;
      const $btns = $('.product_pack_button');
      const quantity_selector_input = $('.product-info__quantity-selector quantity-selector input')[0];

      const current_price = meta && (meta.product.variants[0].price/100);
      if(!current_price) return;
      
      quantity_selector_input.addEventListener('quantity:change', function(e){
        if(_s1.currentProduct.tags.includes('no-tier')) return;
        const qty = Number(e.detail.value);
        const tiers = _s1.getTieredPricing();
        
        if(qty < tiers.low_tier.threshold) return setProductStrikePriceAndRing(true);
        if(qty >= tiers.low_tier.threshold && qty < tiers.mid_tier.threshold) return setProductStrikePriceAndRing(false, current_price - tiers.low_tier.dollars_off);
        if(qty >= tiers.mid_tier.threshold && qty < tiers.high_tier.threshold) return setProductStrikePriceAndRing(false, current_price - tiers.mid_tier.dollars_off);
        return setProductStrikePriceAndRing(false, current_price - tiers.high_tier.dollars_off);
      })
      
      $btns.click(function(){
        
        const $btn = $(this);
        const qty = $(this).data('qty');

        gtag('event', 'pack_quick_add', {
            'product_handle': new URL(window.location.href).pathname.split('/products')[1],
            'pack_option': qty
         })
        
        quantity_selector_input.quantity = Number(qty);
      })
      
    }

    // ******** End New Pack Buttons

    // ******** Start Complete Pack

    const triggerAddMore = (e) => {
      const ele = !!e.target ? e.target : e;

      const variantId = ele.dataset.variantId;
      const itemQty = Number(ele.dataset.qty);
      const CartQty = Number(ele.dataset.currentCart);

      // Get tier thresholds from settings
      const tiers = _s1.getTieredPricing();
      const lowTier = tiers.low_tier.threshold;
      const midTier = tiers.mid_tier.threshold;
      const highTier = tiers.high_tier.threshold;

      // Determine which tier to target based on current cart quantity
      let targetTier;
      if (CartQty < lowTier) {
        targetTier = lowTier;
      } else if (CartQty < midTier) {
        targetTier = midTier;
      } else if (CartQty < highTier) {
        targetTier = highTier;
      } else {
        // If already at highest tier, don't add more
        return;
      }

      const increaseQty = targetTier - CartQty;

      const items = [{
        id: variantId,
        quantity: increaseQty
      }]

      _s1.addToCartAndRefreshCart(items);

      gtag('event', 'addMoreClick', {
        to_tier: targetTier,
        before_cart_qty: CartQty,
        qty_added: increaseQty
      })
    }

    window.triggerAddMore = triggerAddMore;

    // ******** End Complete Pack

     if(window.location.href.includes('/products/cloud-mesh')){
      _s1.artificalRemoveStock();
    }

    setPackButtonsQuantity();
    addAttributeForRefferingFriend();
    initFatherAndSon();
    //initScrollFromBanner();
    //initProductCardsSwatches();
    initSurfPages();
    initSurfDonationBanner(); 
    initDiscountBarV3();
    initProductCardSwatchesV2();
    initProductCardSwitcher();
    initAmbassadorTracking();
    showGenderProductTab();
    initCloudMeshSignUp();
    
  })
  
  
})()